/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EpaOperatorNotificationRequest } from './EpaOperatorNotificationRequest';
import {
    EpaOperatorNotificationRequestFromJSON,
    EpaOperatorNotificationRequestFromJSONTyped,
    EpaOperatorNotificationRequestToJSON,
    EpaOperatorNotificationRequestToJSONTyped,
} from './EpaOperatorNotificationRequest';

/**
 * Serializer for the EpaForm model.
 * @export
 * @interface PatchedEpaFormRequest
 */
export interface PatchedEpaFormRequest {
    /**
     * 
     * @type {EpaOperatorNotificationRequest}
     * @memberof PatchedEpaFormRequest
     */
    operatorNotification?: EpaOperatorNotificationRequest;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedEpaFormRequest
     */
    responsibleForEmission?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaFormRequest
     */
    epaId?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaFormRequest
     */
    apiWellId?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaFormRequest
     */
    facilityName?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaFormRequest
     */
    address?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedEpaFormRequest
     */
    assertDemonstrableError?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaFormRequest
     */
    statementDemonstrableError?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedEpaFormRequest
     */
    affectedFacility?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedEpaFormRequest
     */
    identifiedSource?: boolean | null;
    /**
     * 
     * @type {any}
     * @memberof PatchedEpaFormRequest
     */
    investigationSteps?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaFormRequest
     */
    alternateTestMethods?: string;
    /**
     * 
     * @type {Date}
     * @memberof PatchedEpaFormRequest
     */
    investigationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaFormRequest
     */
    investigationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaFormRequest
     */
    investigationTimezone?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedEpaFormRequest
     */
    certifiesAllInvestigationsDone?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaFormRequest
     */
    sourceOfEmission?: string;
    /**
     * 
     * @type {any}
     * @memberof PatchedEpaFormRequest
     */
    subjectToRegulation?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaFormRequest
     */
    citationOfRegulation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedEpaFormRequest
     */
    eventStillOngoing?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof PatchedEpaFormRequest
     */
    eventEndDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedEpaFormRequest
     */
    isEstimate?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaFormRequest
     */
    eventEndTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaFormRequest
     */
    eventEndTimezone?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PatchedEpaFormRequest
     */
    targetedEndDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaFormRequest
     */
    planForEvent?: string;
}

/**
 * Check if a given object implements the PatchedEpaFormRequest interface.
 */
export function instanceOfPatchedEpaFormRequest(value: object): value is PatchedEpaFormRequest {
    return true;
}

export function PatchedEpaFormRequestFromJSON(json: any): PatchedEpaFormRequest {
    return PatchedEpaFormRequestFromJSONTyped(json, false);
}

export function PatchedEpaFormRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedEpaFormRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'operatorNotification': json['operator_notification'] == null ? undefined : EpaOperatorNotificationRequestFromJSON(json['operator_notification']),
        'responsibleForEmission': json['responsible_for_emission'] === undefined ? undefined : json['responsible_for_emission'] === null ? null : json['responsible_for_emission'],
        'epaId': json['epa_id'] == null ? undefined : json['epa_id'],
        'apiWellId': json['api_well_id'] == null ? undefined : json['api_well_id'],
        'facilityName': json['facility_name'] == null ? undefined : json['facility_name'],
        'address': json['address'] == null ? undefined : json['address'],
        'assertDemonstrableError': json['assert_demonstrable_error'] === undefined ? undefined : json['assert_demonstrable_error'] === null ? null : json['assert_demonstrable_error'],
        'statementDemonstrableError': json['statement_demonstrable_error'] == null ? undefined : json['statement_demonstrable_error'],
        'affectedFacility': json['affected_facility'] === undefined ? undefined : json['affected_facility'] === null ? null : json['affected_facility'],
        'identifiedSource': json['identified_source'] === undefined ? undefined : json['identified_source'] === null ? null : json['identified_source'],
        'investigationSteps': json['investigation_steps'] === undefined ? undefined : json['investigation_steps'] === null ? null : json['investigation_steps'],
        'alternateTestMethods': json['alternate_test_methods'] == null ? undefined : json['alternate_test_methods'],
        'investigationDate': json['investigation_date'] === undefined ? undefined : json['investigation_date'] === null ? null : (new Date(json['investigation_date'])),
        'investigationTime': json['investigation_time'] === undefined ? undefined : json['investigation_time'] === null ? null : json['investigation_time'],
        'investigationTimezone': json['investigation_timezone'] === undefined ? undefined : json['investigation_timezone'] === null ? null : json['investigation_timezone'],
        'certifiesAllInvestigationsDone': json['certifies_all_investigations_done'] === undefined ? undefined : json['certifies_all_investigations_done'] === null ? null : json['certifies_all_investigations_done'],
        'sourceOfEmission': json['source_of_emission'] == null ? undefined : json['source_of_emission'],
        'subjectToRegulation': json['subject_to_regulation'] === undefined ? undefined : json['subject_to_regulation'] === null ? null : json['subject_to_regulation'],
        'citationOfRegulation': json['citation_of_regulation'] == null ? undefined : json['citation_of_regulation'],
        'eventStillOngoing': json['event_still_ongoing'] === undefined ? undefined : json['event_still_ongoing'] === null ? null : json['event_still_ongoing'],
        'eventEndDate': json['event_end_date'] === undefined ? undefined : json['event_end_date'] === null ? null : (new Date(json['event_end_date'])),
        'isEstimate': json['is_estimate'] === undefined ? undefined : json['is_estimate'] === null ? null : json['is_estimate'],
        'eventEndTime': json['event_end_time'] === undefined ? undefined : json['event_end_time'] === null ? null : json['event_end_time'],
        'eventEndTimezone': json['event_end_timezone'] === undefined ? undefined : json['event_end_timezone'] === null ? null : json['event_end_timezone'],
        'targetedEndDate': json['targeted_end_date'] === undefined ? undefined : json['targeted_end_date'] === null ? null : (new Date(json['targeted_end_date'])),
        'planForEvent': json['plan_for_event'] == null ? undefined : json['plan_for_event'],
    };
}

export function PatchedEpaFormRequestToJSON(json: any): PatchedEpaFormRequest {
    return PatchedEpaFormRequestToJSONTyped(json, false);
}

export function PatchedEpaFormRequestToJSONTyped(value?: PatchedEpaFormRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operator_notification': EpaOperatorNotificationRequestToJSON(value['operatorNotification']),
        'responsible_for_emission': value['responsibleForEmission'],
        'epa_id': value['epaId'],
        'api_well_id': value['apiWellId'],
        'facility_name': value['facilityName'],
        'address': value['address'],
        'assert_demonstrable_error': value['assertDemonstrableError'],
        'statement_demonstrable_error': value['statementDemonstrableError'],
        'affected_facility': value['affectedFacility'],
        'identified_source': value['identifiedSource'],
        'investigation_steps': value['investigationSteps'],
        'alternate_test_methods': value['alternateTestMethods'],
        'investigation_date': value['investigationDate'] == null ? value['investigationDate'] : value['investigationDate'].toISOString().substring(0,10),
        'investigation_time': value['investigationTime'],
        'investigation_timezone': value['investigationTimezone'],
        'certifies_all_investigations_done': value['certifiesAllInvestigationsDone'],
        'source_of_emission': value['sourceOfEmission'],
        'subject_to_regulation': value['subjectToRegulation'],
        'citation_of_regulation': value['citationOfRegulation'],
        'event_still_ongoing': value['eventStillOngoing'],
        'event_end_date': value['eventEndDate'] == null ? value['eventEndDate'] : value['eventEndDate'].toISOString().substring(0,10),
        'is_estimate': value['isEstimate'],
        'event_end_time': value['eventEndTime'],
        'event_end_timezone': value['eventEndTimezone'],
        'targeted_end_date': value['targetedEndDate'] == null ? value['targetedEndDate'] : value['targetedEndDate'].toISOString().substring(0,10),
        'plan_for_event': value['planForEvent'],
    };
}

